/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import { Grid, Typography } from '@mui/material';
import _ from 'lodash';
import emptyIcon from '../../../../assets/images/empty_icon.svg';
import { fonts, themes } from '../../../../common/themes/themes';
import AddInsuranceModalController from '../../../../common/Modals/Insurance/AddInsuranceModal/AddInsuranceModalController';
import ExpiredInsuranceViewModalController from '../../../../common/Modals/Insurance/ExpiredInsuranceViewModal/ExpiredInsuranceViewModalController';
import InsuranceContentTile from '../../../../common/components/InsuranceListContent/InsuranceContentTile';
import EditInsuranceModalController from '../../../../common/Modals/Insurance/EditInsuranceModal/EditInsuranceModalController';
import CustomAddButton from '../../../../common/components/CustomAddButton/CustomAddButton';
import ActivedocCard from '../../../../common/components/ActivedocCard';
import { getAmount } from '../../../../common/configs/utils';
import Loader from '../../../../common/Lottifiers/Loader/Loader';

interface propsType {
  insuranceData: any;
  isLoading?: boolean;
  hr_view?: boolean;
  trans?: any;
}

const ActiveLoansPresenter: React.FC<propsType> = ({
  insuranceData,
  isLoading,
  hr_view,
  trans,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [editModal, setEditModal] = useState(false);

  const [insuranceViewData, setInsuranceViewData] = useState({});

  return (
    <>
      <ActivedocCard
        card_title={trans('Insurance')}
        card_height="330px"
        card_subtitle={`${trans('Total')}: ${insuranceData?.length}`}
        onClick={() => setOpenModal(true)}
        isAddButton={true}
      >
        {isLoading ? (
          <Loader height={100} width={200} />
        ) : (
          <div>
            {insuranceData?.length > 0 ? (
              _.map(insuranceData, (data) => {
                return (
                  <InsuranceContentTile
                    key={data?.insurers?.name}
                    insuranceName={
                      data?.insurers?.name ? data?.insurers?.name : '--'
                    }
                    policyNumber={
                      data?.policy_number != 'undefined'
                        ? data?.policy_number
                        : '--'
                    }
                    startDate={data?.start_date}
                    expireDate={data?.expiry_date}
                    amount={
                      data?.amount != 'undefined'
                        ? getAmount(data?.amount)
                        : '0'
                    }
                    policyType={data?.policytype?.name}
                    onClick={() => {
                      setViewModal(true);
                      setInsuranceViewData(data);
                    }}
                    onEdit={() => {
                      setInsuranceViewData(data);
                      setEditModal(true);
                    }}
                    isEdit={true}
                  />
                );
              })
            ) : (
              <Grid container>
                <Grid
                  item
                  xs={12}
                  style={{
                    textAlign: 'center',
                  }}
                >
                  <img src={emptyIcon} />
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    textAlign: 'center',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: fonts.fontFamily,
                      fontSize: fonts.title,
                      color: themes.blackDefault,
                      fontWeight: 'bold',
                    }}
                  >
                    {trans('Not Added')}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    textAlign: 'center',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: fonts.fontFamily,
                      fontSize: fonts.subtitle,
                      color: themes.defaultIcon,
                    }}
                  >
                    {trans('Currently you haven’t any Insurance')}
                  </Typography>
                </Grid>
                {hr_view && (
                  <Grid
                    item
                    xs={12}
                    style={{
                      textAlign: 'center',
                      marginTop: '1em',
                    }}
                  >
                    <CustomAddButton
                      btnLabel={trans('Apply Insurance')}
                      onClick={() => setOpenModal(true)}
                    />
                  </Grid>
                )}
              </Grid>
            )}
          </div>
        )}
      </ActivedocCard>

      {/* Edit Insurance Modal */}

      {editModal && (
        <EditInsuranceModalController
          isModalOpen={editModal}
          closeModal={() => setEditModal(false)}
          data={insuranceViewData}
          trans={trans}
        />
      )}

      {/* Add Insurance Modal */}

      {openModal && (
        <AddInsuranceModalController
          isModalOpen={openModal}
          closeModal={() => setOpenModal(false)}
          trans={trans}
        />
      )}

      {/* View Insurance Modal */}
      {viewModal && (
        <ExpiredInsuranceViewModalController
          isModalOpen={viewModal}
          closeModal={() => setViewModal(false)}
          expiredData={insuranceViewData}
          trans={trans}
        />
      )}
    </>
  );
};

export default ActiveLoansPresenter;
